<template>
  <div>
    <h1 class="text-center">{{ schema.$title }}</h1>

    <fields-required />

    <panel :title="tendererPanelTitle">
      <employer :model="schema.data.tenderer">
        <template slot="artisan">
          <div class="row form-group mt-2">
            <yes-or-no class="col-12" :model="schema.data.tenderer.isArtisan" />
          </div>
        </template>
      </employer>
    </panel>

    <panel :title="employeePanelTitle">
      <employee :model="schema.data.employee" :type-of-profesion="typeOfProfesion" />

      <employee-details :model="schema.data.employee" />
    </panel>

    <panel title="III. Oświadczenia">
      <div class="row form-group">
        <div class="col-12">
          <span v-html="replacePlaceholders(schema.data.personalDataStatement.$title)" />
        </div>
      </div>

      <div class="row form-group">
        <div class="col-12">
          <span v-html="replacePlaceholders(schema.data.criminalResponsibility.$title)" />
        </div>
      </div>
    </panel>

    <panel :title="deMinimisTitle">
      <de-minimis :schema="schema" />
    </panel>

    <panel v-if="schema.data.requiredAttachments" :title="schema.data.requiredAttachments.$title">
      <div v-for="(point, index) of points" :key="'attachment_' + index" class="form-group">
        <yes-or-no v-if="index < 6 && point !== 'd' && point !== 'e'" :model="schema.data.requiredAttachments[point]" />

        <yes-no-not
          v-else-if="point === 'd'"
          :model="schema.data.requiredAttachments.d"
          :disabled="{ all: schema.data.requiredAttachments.e.$model === 1 }"
        />

        <yes-no-not
          v-else-if="point === 'e'"
          :model="schema.data.requiredAttachments.e"
          :disabled="{ all: schema.data.requiredAttachments.d.$model === 1 }"
        />

        <yes-no-not v-else :model="schema.data.requiredAttachments[point]" />
      </div>
    </panel>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import FieldsRequired from '@/components/formComponents/FieldsRequired.vue';
import Panel from '@/components/panel/Panel.vue';
import { ow004Mixin } from '@/mixins/document/ow004';
import { replacePlaceholdersMixin } from '@/mixins/replacePlaceholders';

import DeMinimis from '../deMinimis/DeMinimis';
import Employee from '../Employee.vue';
import EmployeeDetails from '../EmployeeDetails.vue';
import Employer from '../Employer.vue';
import YesNoNot from '../YesNoNotRadio.vue';
import YesOrNo from '../YesOrNoRadio.vue';

// @vuese
// Formularz wzoru OW-004
export default {
  components: {
    DeMinimis,
    Employee,
    EmployeeDetails,
    Employer,
    FieldsRequired,
    Panel,
    YesOrNo,
    YesNoNot,
    ...components
  },
  mixins: [ow004Mixin, replacePlaceholdersMixin],
  props: {
    // schema dokumentu
    schema: { type: Object, required: true }
  },
  computed: {
    tendererPanelTitle() {
      return this.replacePlaceholders(this.schema.data.tenderer.$title);
    },

    employeePanelTitle() {
      return this.replacePlaceholders(this.schema.data.employee.$title);
    },

    profesionTitle() {
      return this.replacePlaceholders(this.schema.data.employee.contractDataStart.$title);
    },

    points() {
      return Object.keys(this.schema.data.requiredAttachments.$model);
    }
  }
};
</script>
